import React, { useRef, useState } from 'react';
import YouTube, { YouTubeProps, YouTubePlayer } from 'react-youtube';

interface VideoPlayerProps {
  videoUrl: string;
  tag?: boolean;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ videoUrl, tag }) => {
  const playerRef = useRef<YouTubePlayer | null>(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [playerReady, setPlayerReady] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const isYouTubeUrl = (url: string) => {
    return url.includes('youtube.com') || url.includes('youtu.be');
  };

  const handlePlayButtonClick = () => {
    if (isYouTubeUrl(videoUrl)) {
      if (playerRef.current) {
        playerRef.current.playVideo();
        setIsPlaying(true);
      }
    } else {
      if (videoRef.current) {
        videoRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const opts: YouTubeProps['opts'] = {
    height: '390',
    width: '640',
    playerVars: {
      autoplay: 0,
    },
  };

  const videoId = isYouTubeUrl(videoUrl) ? videoUrl.split('v=')[1]?.split('&')[0] : undefined;

  const handlePlayerReady: YouTubeProps['onReady'] = (event) => {
    playerRef.current = event.target;
    setPlayerReady(true);
  };

  const handleVideoEnded = () => {
    setIsPlaying(false);
  };

  return (
    <>
      <div className="video-player">
        {!isPlaying && <figure className="video-player__cover"></figure>}
        {isYouTubeUrl(videoUrl) ? (
          <YouTube 
            videoId={videoId} 
            opts={opts} 
            onReady={handlePlayerReady}
            onEnd={handleVideoEnded}
          />
        ) : (
          <video
            ref={videoRef}
            width="640"
            height="390"
            controls={isPlaying}
            onEnded={handleVideoEnded}
            style={{ display: isPlaying ? 'block' : 'none' }}
          >
            <source src={videoUrl} type="video/mp4" />
            Tu navegador no soporta el elemento de video.
          </video>
        )}
        {!isPlaying && (
          <button
            onClick={handlePlayButtonClick}
            disabled={!playerReady && isYouTubeUrl(videoUrl)}
            className="btn btn--video"
          >
            <span className="material-symbols-outlined icon">play_circle</span>
          </button>
        )}
      </div>
      {tag && (
        <div className="video-tag">
          <p>
            ¿No carga el video? Consúltelo en{' '}
            <a href="https://www.youtube.com/@siticsoftware" target="_blank" rel="noreferrer">
              <span>nuestro canal de Youtube</span>{' '}
              <span className="material-symbols-outlined icon">open_in_new</span>
            </a>
          </p>
        </div>
      )}
    </>
  );
};

export default VideoPlayer;
